<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>Society Details</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="$router.go(-1)">
              <v-icon left>
                mdi-chevron-double-left 
              </v-icon>
              {{ $t('society.list.basicDetails.buttons.back') }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="#f4f5f7 black--text"> 
            <v-row>
              <v-col cols="12">
                <v-tabs
                  color="primary"
                  v-model="currentTab"
                  @change="storeSelectedTabValue"
                >
                  <v-tab v-for="tab in tabs" :key="tab.name" :href="'#'+tab.name">
                    {{ tab.name }}
                  </v-tab>

                  <v-tabs-items v-model="currentTabComponent" class="pa-4">
                    <component v-bind:is="currentTabComponent" :society_id="society_id"></component>
                  </v-tabs-items>
                  
                </v-tabs>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import BasicInformation from './BasicInformation.vue'
import Members from './Members.vue'
  
export default {
  components: {
    BasicInformation,
    Members,
  },
  data() {
    return {
      loading: false,
      society_id: "",
      tabs: [
        { name : 'Basic', component : 'BasicInformation' },
        { name : 'Members', component : 'Members' },
      ],
      currentTab: '',
      search: '',
    };
  },
  computed: {
    currentTabComponent:function() {
      let tab = this.tabs.find(tab => tab.name == this.currentTab);
      return tab ? tab.component : '';
    }
  },  
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    ...mapMutations("society",["setSelectedTab"]),
    storeSelectedTabValue() {
      this.setSelectedTab({
        selectedTab : this.currentTab
      });
    }
  },
  mounted() {
    this.society_id = this.$route.params.id;
    if(![null, undefined,''].includes(this.$store.state.society.selectedTab)) {
      this.currentTab = this.$store.state.society.selectedTab;
    }
  },
};
</script>